// extracted by mini-css-extract-plugin
module.exports =  {"timeWrapper":"Courses__time-wrapper"};